<div class="container-fluid p-0">
  <div class="row">
    <div class="col">
      <div class="modal-body">
        <div class="row">
          <div class="col">
            <h4>
              Review & Verification: Please review and verify that the
              information entered is correct before you proceed with completing
              your search and incur $ costs.
            </h4>
            <hr class="seperator" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <label>Requester Name:</label>
          </div>
          <div class="col-md-8">
            <p>
              {{ ClientRegisteredVendor.requesterFirstName }}
              {{ ClientRegisteredVendor.requesterLastName }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label>Legal Name:</label>
          </div>
          <div class="col-md-8">
            <p>{{ ClientRegisteredVendor.legalName }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label>Tax Identification:</label>
          </div>
          <div class="col-md-8">
            @if (ClientRegisteredVendor.ein) {
              <p>EIN</p>
            }
            @if (ClientRegisteredVendor.ssn) {
              <p>SSN</p>
            }
          </div>
        </div>
        @if (ClientRegisteredVendor.ein) {
          <div class="row">
            <div class="col-md-4">
              <label>EIN:</label>
            </div>
            <div class="col-md-8">
              <p>{{ ClientRegisteredVendor.ein }}</p>
            </div>
          </div>
        }
        @if (ClientRegisteredVendor.ssn) {
          <div class="row">
            <div class="col-md-4">
              <label>SSN:</label>
            </div>
            <div class="col-md-8">
              <p>{{ ClientRegisteredVendor.ssn }}</p>
            </div>
          </div>
        }

        <div class="row">
          <div class="col-md-4">
            <label>Street Address:</label>
          </div>
          <div class="col-md-8">
            <p>
              {{ ClientRegisteredVendor.StreetAddress?.address1 }}
              {{ ClientRegisteredVendor.StreetAddress?.address2 || '' }}
              {{ ClientRegisteredVendor.StreetAddress?.city }},
              {{ ClientRegisteredVendor.StreetAddress?.state }}
              {{ ClientRegisteredVendor.StreetAddress?.zip }}
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label>Mailing Address: </label>
          </div>
          <div class="col-md-8">
            <p>
              {{ ClientRegisteredVendor.MailingAddress?.address1 }}
              {{ ClientRegisteredVendor.MailingAddress?.address2 || '' }}
              {{ ClientRegisteredVendor.MailingAddress?.city }},
              {{ ClientRegisteredVendor.MailingAddress?.state }}
              {{ ClientRegisteredVendor.MailingAddress?.zip }}
            </p>
          </div>
        </div>
        <div class="row" ng-if="ClientRegisteredVendor.stateToVerify">
          <div class="col-md-4">
            <label>Which State will the services be performed?: </label>
          </div>
          <div class="col-md-8">
            <p>{{ ClientRegisteredVendor.stateToVerify }}</p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row w-100 justify-content-end">
          <div class="col-md-4">
            <button class="btn btn-primary" (click)="cancel()">Cancel</button>
          </div>
          <div class="col-md-4">
            <button class="btn btn-primary" (click)="continue()">
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
